// extracted by mini-css-extract-plugin
export default {"form":"JDC3hLUB","mobile":"mobile","row":"h3cJsTZV","phoneGroup":"yWKIxFSO","field":"R3lDNJbH","phone":"K16EITD1","phoneApprove":"pAp85PsH","date":"vlqhCmXK","rules":"KN9066SL"};